export const CUSTOM_CLAIM_NAMESPACE = 'https://dashboard.tryfinch.com';
